import { DateTime } from 'aos-helpers/src/helpers/Time'
import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { Color } from 'aos-ui-common/src/styles/Color'
import { colors } from 'aos-ui-universal/src/tokens'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { AosSeverity } from '../../common/types/AosSeverity'

export enum TaskStatus {
    Todo = 'TODO',
    InProgress = 'IN_PROGRESS',
    OnHold = 'ON_HOLD',
    Done = 'DONE',
    Cancelled = 'CANCELLED',
}
export const statusTextColorsMapping: Record<TaskStatus, Color> = {
    [TaskStatus.Todo]: colors.content.default,
    [TaskStatus.InProgress]: colors.content.default,
    [TaskStatus.OnHold]: colors.content.default,
    [TaskStatus.Done]: Color.SideMenuInactive,
    [TaskStatus.Cancelled]: Color.SideMenuInactive,
}

export const taskStatuses: TaskStatus[] = EnumValues.getValues(TaskStatus)
export const translateTaskTitle = (t: TFunction) => translateEnum(t)(TaskStatus, 'task-status')
export const translateTaskBillable = (t: TFunction) => (billable: boolean) =>
    billable ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' })

export interface TaskDuration {
    hour: number
    minute: number
    startTime?: DateTime
    endTime?: DateTime
}

export interface TaskStatusUpdate {
    status: TaskStatus
    spendTimeInMinutes?: number
    severity?: AosSeverity
    startTime?: DateTime
    endTime?: DateTime
}

export type TaskStatusUpdateDto = Omit<TaskStatusUpdate, 'severity'>
